import React from 'react'
import UploadStore from '../../stores/upload-store'
import createReactClass from 'create-react-class'


var UploadProgressBar = createReactClass({

    componentDidMount: function () {
        //Listen for changes in the UploadStore
        UploadStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        //Stop listening for changes in the UploadStore
        UploadStore.removeChangeListener(this._onChange);
    },
    getInitialState: function () {
        //The state for this component is managed in the UploadStore
        return UploadStore.getData();
    },

    //Get the upload percent progress
    getProgress: function () {
        return Math.round((this.state.totalImagesUploaded / this.state.totalImagesToUpload) * 100);
    },
    //Is the uploader currently uploading?
    isUploading: function () {
        if (!this.state.uploadStarted) {
            return false;
        }
        if (this.state.totalImagesUploaded < this.state.totalImagesToUpload) {
            return true;
        }
        return false;
    },

    //This is called when the store has some updated data for us
    _onChange: function () {
        this.setState(UploadStore.getData());
    },

    //Render the HTML for the component
    render: function () {
        if (this.isUploading()) {
            return (
                <div id="uploadProgressBar">
                    <div className="progress large-12 success round">
                        <span className="meter" style={{width: this.getProgress() + '%'}}></span>
                        <span>{_("Your photos are uploading: %s of %s complete", this.state.totalImagesUploaded, this.state.totalImagesToUpload)}</span>
                    </div>
                </div>
            );
        } else if (this.state.totalImagesToUpload && this.state.totalImagesUploaded == 0) { //Images added but upload not started yet
            return (
                <div id="uploadProgressBar">
                    <div className="progress large-12 success round">
                        <span className="meter" style={{width: '0%'}}></span>
                        <span>{_("Photos added: ‘%s’ to your collection", this.state.totalImagesToUpload)}</span>
                    </div>
                </div>
            );
        } else if (this.state.totalImagesToUpload == this.state.totalImagesUploaded && this.state.totalImagesToUpload > 0) { //Images finished uploading
            return (
                <div id="uploadProgressBar">
                    <div className="progress large-12 success round">
                        <span className="meter" style={{width: this.getProgress() + '%'}}></span>
                        <span>{_("%s of %s uploaded", this.state.totalImagesUploaded, this.state.totalImagesToUpload)}</span>
                    </div>
                </div>
            );
        } else { //No images selected for uploading yet
            return (<div></div>);
        }
    }
});

export default UploadProgressBar;
